import React from "react";
import { Outlet, Navigate } from "react-router-dom";

function ProtectedRoute() {
  const userType = sessionStorage.getItem("user");

  return userType ? <Outlet></Outlet> : <Navigate to="/login"></Navigate>;
}

export default ProtectedRoute;
